<!---
    /**
    * File and all contents are proprietary work of Collsys Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a div with a sticky scrollbar
    * https://jsfiddle.net/TBnqw/2288/
    *
    * @since 20250331
    * @author Thomas Higham <thomash@collsys.co.uk>
    *
    * @copyright (c) 2025 Collsys Ltd. All right Reserved.
    */
--->
<template>
    <div :key="the_id">
        <div style="overflow:auto;" :id="'sticky_main_scroll_' + the_id">
            <slot></slot>
        </div>
        <div :id="'sticky_scroll_' + the_id">
            <div :id="'fake_content_' + the_id"></div>
        </div>
    </div>
</template>

<script>
    //stores a counter of ids so that each tooltip has a unique id for reference
    export const store = {
        state: 1,
        increment() {
            ++this.state
        }
    };
    export default{
        props: {
            
        },
        mounted() {
            this.the_id = store.state;
            store.increment();
            var self = this;
            setTimeout(function(){
                self.mainDiv = $('#sticky_main_scroll_' + self.the_id);
                self.scrollbar = $('#sticky_scroll_' + self.the_id);
                self.scrollbar.hide().css({
                    overflowX:'auto',
                    position:'fixed',
                    width:'100%',
                    bottom:0
                });
                self.fakecontent = $('#fake_content_' + self.the_id);
                self.scrollbar.scroll(self.scroll);
        
                self.onscroll();
                $(window).scroll(self.onscroll);
                $(window).resize(self.onscroll);
            }, 1000);
            
        },
        data() {
            return {
                // the unique id
                the_id: 1,
                lastScroll: 0,
                activeActual: $([]),
                scrollbar: null,
                fakecontent: null,
                mainDiv: null
            }
        },
        computed: {
        },
        methods: {
            top: function(e) {
                return e.offset().top;
            },

            bottom: function(e) {
                return e.offset().top + e.height();
            },
            
            find_active: function () {
                this.scrollbar.show();
                var active = $([]);
                var self = this;
                if (self.top(this.mainDiv) < self.top(self.scrollbar) && self.bottom(this.mainDiv) > self.bottom(self.scrollbar)) {
                    self.fakecontent.width(this.mainDiv.get(0).scrollWidth);
                    self.fakecontent.height(1);
                    active = this.mainDiv;
                }
                this.fit(active);
                return active;
            },
            
            fit: function (active) {
                if (!active.length) return this.scrollbar.hide();
                this.scrollbar.css({left: active.offset().left, width:active.width()});
                this.fakecontent.width($(this).get(0).scrollWidth);
                this.fakecontent.height(1);
                delete this.lastScroll;
            },
            
            onscroll: function (){
                var oldactive = this.activeActual;
                this.activeActual = this.find_active();
                if (oldactive.not(this.activeActual).length) {
                    oldactive.unbind('scroll', this.update);
                }
                if (this.activeActual.not(oldactive).length) {
                    this.activeActual.scroll(this.update);
                }
                this.update();
            },
            
            scroll: function () {
                if (!this.activeActual.length) return;
                if (this.scrollbar.scrollLeft() === this.lastScroll) return;
                this.lastScroll = this.scrollbar.scrollLeft();
                this.activeActual.scrollLeft(this.lastScroll);
            },
            
            update: function () {
                if (!this.activeActual.length) return;
                if (this.activeActual.scrollLeft() === this.lastScroll) return;
                this.lastScroll = this.activeActual.scrollLeft();
                this.scrollbar.scrollLeft(this.lastScroll);
            }
        }
    }
</script>